import buyingOptions from '../../global-config-variables/buying-options';

export const BUYING_OPTIONS = buyingOptions;
